'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _params = require('hub-http/helpers/params');

exports.default = function (backdoorKey, search) {
  var queryString = search.substr(1);
  var params = (0, _params.parse)(queryString);
  return Boolean(params[backdoorKey]) === true;
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/utils/hasBackdoor.js
// module id = 589
// module chunks = 3 4